export enum SystemUserTypes {
    CRM = 'crm',
    ADMIN = 'admin',
    CLIENT = 'client',
    SUB_CLIENT = 'subclient',
    SUPER_ADMIN = 'superadmin',
}
